import { z } from 'zod';
import { IsoDateTimeSchema } from './common.js';

/** Dienst-Verbindung (PV-052 L4): Anzeige-Zustand in der Admin-Karte „Float-Verbindung“. */
export const DienstStatusWertSchema = z.enum([
  'verbunden',
  'widerrufen',
  'nicht_verbunden',
  'andere_adresse',
  'nicht_erreichbar',
  'nicht_konfiguriert',
]);
export type DienstStatusWert = z.infer<typeof DienstStatusWertSchema>;

export const DienstStatusSchema = z.object({
  status: DienstStatusWertSchema,
  /** Konfigurierte Adresse (FLOAT_MCP_URL), leer wenn nicht konfiguriert. */
  mcp_url: z.string(),
  verbunden_von_name: z.string().nullable(),
  verbunden_am: IsoDateTimeSchema.nullable(),
});
export type DienstStatus = z.infer<typeof DienstStatusSchema>;

export const DienstTestErgebnisSchema = z.object({
  ok: z.boolean(),
  tools: z.number().int().nonnegative(),
});
export type DienstTestErgebnis = z.infer<typeof DienstTestErgebnisSchema>;
